import { useParams, routes, useLocation } from '@redwoodjs/router'

import CreateChangeOrderCell from 'src/components/CreateChangeOrderCell'
import CreateChangeOrderWithMultiplePartsCell from 'src/components/CreateChangeOrderWithMultiplePartsCell'
import CreateChangeOrder from 'src/components/CreateChangeOrderCell/CreateChangeOrder'
import { useChangeType } from 'src/components/hooks'

export const CREATE_CHANGE_ORDER = gql`
  mutation CreateChangeOrderMutation ($name: String!, $description: String!, $type: OrderType) {
    createChangeOrder(input: { name: $name, description: $description, type: $type }) {
      name
      number
      type
    }
  }
`

export const ADD_TO_NEW_CHANGE_ORDER_MUTATION = gql`
mutation AddToNewChangeOrderMutation ($changeOrderNumber: Int!, $input: [PartDeltaInput!]!) {
  addPartDeltas(changeOrderNumber: $changeOrderNumber, input: $input) {
    partNumber
  }
}
`

const CreateChangeOrderPage = () => {
  const { isChangeRequest } = useChangeType()

  if (isChangeRequest) {
    return <CreateChangeOrder />
  }

  const { withPartNumber, withPartNumbers } = useParams();
  if (withPartNumber) {
    return <CreateChangeOrderCell partNumber={withPartNumber} />
  }
  else if (withPartNumbers) {
    const partNumbers = withPartNumbers.split(',').map(atob)
    return <CreateChangeOrderWithMultiplePartsCell partNumbers={partNumbers} />
  }
  return <CreateChangeOrder />
}

export default () => {
  return <div className='max-w-[1200px] mx-auto px-6 pb-12 pt-6'>
    <CreateChangeOrderPage />
  </div>
}
